<template>
  <!--编辑服务-->
  <div class="my_service_edit">
    <div class="tit">
          <span>
            <router-link
                to="/personal_center/service_provider/my_service/list"
                class="back"
            >
              <i class="el-icon-arrow-left"></i>
            </router-link>服务编辑
          </span>
    </div>
    <div class="body_content">
      <div class="form">
        <!--        <div  style="background-color:#f5f5f5; font-weight: bold;margin-bottom: 10px;padding: 15px">-->
        <!--          温馨提示：新增并审核通过的服务将在本园区小程序展示，并且同步在 <a href="https://www.sctcc.cn/#/supermarket" target="_blank" style="color: #117EFF">华转网科技Mall</a> 展示-->
        <!--        </div>-->
        <el-form :model="form" ref="form" :label-width="formLabelWidth" label-position="top">
          <el-row>
            <el-col :span="18">
              <el-form-item
                  label="封面图"
                  prop="cover"
                  :rules="[{required: true, message: '请上传封面', trigger: 'blur,click'}]"
              >
                <div class="myupload">
                  <div class="myupload_l">
                    <AppCropper
                        :params="form"
                        @uploadObj="uploadObj"
                        :uploadParams="uploadParams"
                    />
                  </div>
                  <div class="myupload_r">
                    <p>1.请上传商品封面图片,文件格式为jpg,png,bmp,tif,gif,大小不超过500kb</p>
                    <p>2.商品封面将展示在店铺首页、商品详情页主图，图片中不得有任何与商品本身无关的内容</p>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!--          <el-row>-->
          <!--            <el-col :span="18">-->
          <!--              <el-form-item-->
          <!--                  label="广告图一"-->
          <!--                  prop="cover2"-->
          <!--                  :rules="[{required: true, message: '请上传广告图', trigger: 'blur,click'}]"-->
          <!--              >-->
          <!--                <div class="myupload">-->
          <!--                  <div class="myupload_l">-->
          <!--                    <AppCropper-->
          <!--                        :params="form"-->
          <!--                        @uploadObj="uploadObj"-->
          <!--                        :uploadParams="uploadParams3"-->
          <!--                    />-->
          <!--                  </div>-->
          <!--                  <div class="myupload_r">-->
          <!--                    <p>1.请上传商品“矩形”广告图片,文件格式为jpg,png,bmp,tif,gif,大小不超过500kb</p>-->
          <!--                    <p>2.广告图片将可能展示在TOPS新家园和华转网科技Mall首页推荐窗口店铺首页、相关服务的推荐广告位，请注意图片中不得有任何与服务本身无关的内容或违法广告法等相关法律法规的内容。</p>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </el-form-item>-->
          <!--            </el-col>-->
          <!--          </el-row>-->
          <!--          <el-row>-->
          <!--            <el-col :span="18">-->
          <!--              <el-form-item-->
          <!--                  label="广告图二"-->
          <!--                  prop="cover3"-->
          <!--                  :rules="[{required: true, message: '请上传广告图', trigger: 'blur,click'}]"-->
          <!--              >-->
          <!--                <div class="myupload">-->
          <!--                  <div class="myupload_l">-->
          <!--                    <AppCropper-->
          <!--                        :params="form"-->
          <!--                        @uploadObj="uploadObj"-->
          <!--                        :uploadParams="uploadParams5"-->
          <!--                    />-->
          <!--                  </div>-->
          <!--                  <div class="myupload_r">-->
          <!--                    <p>1.请上传商品“方形”广告图片,文件格式为jpg,png,bmp,tif,gif,大小不超过500kb</p>-->
          <!--                    <p>2.广告图片将可能展示在TOPS新家园和华转网科技Mall首页推荐窗口店铺首页、相关服务的推荐广告位，请注意图片中不得有任何与服务本身无关的内容或违法广告法等相关法律法规的内容。</p>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </el-form-item>-->
          <!--            </el-col>-->
          <!--          </el-row>-->
          <el-row>
            <el-col :span="18">
              <el-form-item
                  label="详情图"
                  :label-width="formLabelWidth"
                  prop="image_details"
                  :rules="[{required: true, message: '请上传详情图', trigger: 'blur,click'}]"
              >
                <div class="myupload">
                  <div class="myupload_l">
                    <CropperMulti
                        :params="form"
                        @uploadObj="uploadMultiObj"
                        @remove="uploadRemove"
                        :uploadParams="uploadParams2"
                    />
                  </div>
                  <div class="myupload_r">
                    <p>1.详情图文件格式为jpg,png,bmp,tif,gif;大小不超过500kb,最多5张</p>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item
                  label="服务名称"
                  prop="name"
                  :rules="[{ required: true, message: '请输入服务名称', trigger: 'blur' }]"
                  :label-width="formLabelWidth"
              >
                <el-input
                    style="width: 450px"
                    v-model="form.name"
                    placeholder="请输入服务名称"
                    maxlength="30"
                    show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item
                  label="所在地"
                  prop="city"
                  :rules="[{ required: true, message: '请选择所在地', trigger: 'blur' }]"
                  :label-width="formLabelWidth"
              >
                <provincialSelection width="220px" :params="form"></provincialSelection>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                  label="服务类型"
                  prop="class_one"
                  :rules="[{ required: true, message: '请选择服务类型', trigger: 'blur' }]"
                  :label-width="formLabelWidth"
              >
                <el-select
                    v-model="form.class_one"
                    style="margin-right: 10px;width: 220px"
                    placeholder="请选择服务类型"
                    disabled
                >
                  <!--                  <el-option label="研究开发服务" value="RangeServicesResearch"></el-option>-->
                  <!--                  <el-option label="检验检测服务" value="RangeServicesCheck"></el-option>-->
                  <!--                  <el-option label="大型科学仪器设施共享服务" value="RangeServicesShare"></el-option>-->
                  <el-option label="其它" value="RangeServicesOther"></el-option>
                </el-select>
                <el-select
                    v-model="form.class_two"
                    style="width: 220px"
                    placeholder="请选择服务类型子类型"
                >
                  <el-option
                      v-for="item in class_two_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div
              v-if="form.class_two === 'RangeServicesOtherLegalAid' && !form.id"
              style="font-size: 14px;padding-bottom: 20px;background-color: #f5f5f5;padding: 15px"
          >
            <i class="el-icon-warning" style="opacity: 0.5;margin-right: 5px"></i>
            提示：请先点击 <span style="color: #117EFF">“暂存”</span>按钮，设置法律服务园区及服务时间。
          </div>
          <el-row>
            <el-col :span="18">
              <el-form-item
                  label="关键词"
                  prop="keyword_arr"
                  :rules="[{ required: true, message: '请添加关键词', trigger: 'blur' }]"
                  :label-width="formLabelWidth"
              >
                <myTag :dynamicTags="form.keyword_arr" label="关键词" :size="8"></myTag>
                <span class="color_gary">注：关键词最多可以输入8个，列表显示前三个，英文长度不超过10个，中文不超过5个字。</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item
                  label="规格"
                  prop="scales"
                  :rules="[{ required: true, message: '请添加规格', trigger: 'blur' }]"
                  :label-width="formLabelWidth"
              >
                <div>
                  <el-button type="primary" @click="dialogAddVisible = true">添加</el-button>
                </div>
                <myTable
                    style="margin-top: 15px"
                    :tableObj="tableObj"
                    @btnClick="btnClick"
                ></myTable>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item
                  label="服务详情"
                  prop="synopsis"
                  :rules="[{ required: true, message: '请输入服务详情', trigger: 'blur' }]"
              >
                <tinymce_editor v-model="form.synopsis" v-if="!loading"></tinymce_editor>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
              label="上传商品附件"
              prop="file"
          >
            <div class="myupload">
              <div class="myupload_l">
                <uploadFile
                    :params="form" :apiParams="apiParams"
                ></uploadFile>
                <input type="hidden" v-model="form.file"/>
              </div>
              <div class="myupload_r">
                <p>1、包括但不限于服务合同模板/服务使用说明手册/仪器使用注意事项等</p>
                <p>2、如有多个文档，请打包为一个压缩包上传，格式为rar,zip,大小不超过5M</p>
                <p v-if="form.filePath">
                  <a
                      target="_blank"
                      style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                      :href="form.filePath"
                      download="商品附件"
                  >查看附件</a>
                </p>
              </div>
            </div>
          </el-form-item>
          <!-- 法律援助 -->
          <el-row v-if="form.class_two === 'RangeServicesOtherLegalAid' && form.id">
            <el-col :span="18">
              <el-form-item
                  label="咨询服务"
                  prop="legalAid"
                  :rules="[{ required: true, message: '请添加规格', trigger: 'blur' }]"
                  :label-width="formLabelWidth"
              >
                <div>
                  <el-button type="primary" @click="dialogAddVisible2 = true">添加</el-button>
                </div>
                <table class="legalAid mt20">
                  <tr class="legalAid_head">
                    <!--                    <th>业务园区</th>-->
                    <th>时间段</th>
                    <th>开始时间</th>
                    <th>结束时间</th>
                    <th>单位服务时间</th>
                    <th>操作</th>
                  </tr>
                  <template v-for="item in legalAid">
                    <tr v-for="it,idx in item.arr">
                      <!--                      <td v-if="idx === 0" :rowspan="item.arr.length">{{it.name}}</td>-->
                      <td>{{it.service_time_slot}}</td>
                      <td>{{it.service_begin_date}}</td>
                      <td>{{it.service_end_date}}</td>
                      <td>{{it.service_unit_time}}</td>
                      <td>
                        <div class="opts">
                          <div class="opt_btn" @click="tableOpt('edit', it)">编辑</div>
                          <div class="opt_btn" @click="tableOpt('delete', it)">移除</div>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="!legalAid.length">
                    <td colspan="5">暂无数据</td>
                  </tr>
                </table>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!--添加规格弹窗-->
        <el-dialog
            custom-class="add"
            :visible.sync="dialogAddVisible"
            title="新增规格"
            :close-on-click-modal="false"
            width="650px"
        >
          <el-form :model="spec" ref="spec">
            <el-form-item
                prop="name"
                label="规格名称"
                label-width="100px"
                :rules="[{required: true, message: '请输入规格名称', trigger: 'blur'},{ max: 50, message: '长度在 50 个字符内', trigger: 'blur' }]"
            >
              <el-input
                  maxlength="50"
                  show-word-limit
                  v-model="spec.name"
                  placeholder="示例：单个指标测试 (无规格可填写默认)"
              ></el-input>
            </el-form-item>

            <el-form-item
                prop="unit"
                label="规格单位"
                label-width="100px"
                :rules="[{ required: true, message: '请输入规格单位', trigger: 'blur' },{ max: 50, message: '长度在 50 个字符内', trigger: 'blur' }]"
            >
              <el-input v-model="spec.unit" placeholder="示例：个"></el-input>
            </el-form-item>
            <el-form-item
                prop="money"
                label="规格价格"
                label-width="100px"
                :rules="[{ required: true, message: '请输入规格价格', trigger: 'blur' }]"
            >
              <el-input-number
                  v-model="spec.money"
                  :controls="false"
                  :min="0"
                  placeholder="示例：8888.00"
                  @blur="resetMoney(spec.money)"
              ></el-input-number>
              元（只支持纯数字输入）
            </el-form-item>
            <el-form-item
                prop="original_money"
                label="规格原价"
                label-width="100px"
                :rules="[{ required: true, message: '请输入规格原价', trigger: 'blur' }]"
            >
              <el-input-number
                  v-model="spec.original_money"
                  :controls="false"
                  :min="0"
                  placeholder="示例：8888.00"
                  @blur="resetOriMoney(spec.original_money)"
              ></el-input-number>
              元（只支持纯数字输入）
            </el-form-item>
            <el-form-item
                prop="nums"
                label="可售数量"
                label-width="100px"
                :rules="[{ required: true, message: '请输入可售数量', trigger: 'blur' },]"
            >
              <el-input-number
                  v-model="spec.nums"
                  :controls="false"
                  :min="0"
                  placeholder="示例：9999"
                  @blur="filterNum(spec.nums)"
              ></el-input-number>&nbsp;&nbsp;&nbsp;&nbsp;（只支持纯数字输入）
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button type="primary" @click="saveSpec">保存</el-button>
          </div>
        </el-dialog>

        <!--添加法律援助弹窗-->
        <el-dialog
            custom-class="add"
            :visible.sync="dialogAddVisible2"
            title="添加预约时间"
            :close-on-click-modal="false"
            @close="closeLegalDialog"
            width="650px"
        >
          <el-form :model="legalAidRow" ref="legal">
            <!--            <el-form-item-->
            <!--                prop="incubator"-->
            <!--                label="关联园区"-->
            <!--                label-width="100px"-->
            <!--                :rules="[{required: true, message: '请选择规格园区', trigger: 'blur'},{ max: 50, message: '长度在 50 个字符内', trigger: 'blur' }]"-->
            <!--            >-->
            <!--              <el-select v-model="legalAidRow.incubator" placeholder="请选择">-->
            <!--                <el-option-->
            <!--                    v-for="item in enterprisePark"-->
            <!--                    :key="item.incubator"-->
            <!--                    :label="item.extend1"-->
            <!--                    :value="item.incubator">-->
            <!--                </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item
                prop="service_time_slot"
                label="时间段"
                label-width="120px"
                :rules="[{ required: true, message: '请选择时间段', trigger: 'blur' }]"
            >
              <el-select v-model="legalAidRow.service_time_slot" placeholder="请选择" @change="changeTimeSlot">
                <el-option label="每周一上午" value="每周一上午"></el-option>
                <el-option label="每周一下午" value="每周一下午"></el-option>
                <el-option label="每周二上午" value="每周二上午"></el-option>
                <el-option label="每周二下午" value="每周二下午"></el-option>
                <el-option label="每周三上午" value="每周三上午"></el-option>
                <el-option label="每周三下午" value="每周三下午"></el-option>
                <el-option label="每周四上午" value="每周四上午"></el-option>
                <el-option label="每周四下午" value="每周四下午"></el-option>
                <el-option label="每周五上午" value="每周五上午"></el-option>
                <el-option label="每周五下午" value="每周五下午"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="legalAidRow.service_time_slot.indexOf('上午') !== -1">
              <el-form-item
                  prop="service_begin_date"
                  label="开始时间"
                  label-width="120px"
                  :rules="[{ required: true, message: '请选择开始时间', trigger: 'blur' }]"
              >
                <el-time-select
                    placeholder="开始时间"
                    v-model="legalAidRow.service_begin_date"
                    :picker-options="{
                    start: '08:30',
                    step: '00:30',
                    end: '11:30'
                  }">
                </el-time-select>
              </el-form-item>
              <el-form-item
                  prop="service_end_date"
                  label="结束时间"
                  label-width="120px"
                  :rules="[{ required: true, message: '请选择结束时间', trigger: 'blur' }]"
              >
                <el-time-select
                    placeholder="结束时间"
                    v-model="legalAidRow.service_end_date"
                    :picker-options="{
                    start: '09:30',
                    step: '00:30',
                    end: '12:30'
                  }">
                </el-time-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item
                  prop="service_begin_date"
                  label="开始时间"
                  label-width="120px"
                  :rules="[{ required: true, message: '请选择开始时间', trigger: 'blur' }]"
              >
                <el-time-select
                    placeholder="开始时间"
                    v-model="legalAidRow.service_begin_date"
                    :picker-options="{
                    start: '13:30',
                    step: '00:30',
                    end: '16:30'
                  }">
                </el-time-select>
              </el-form-item>
              <el-form-item
                  prop="service_end_date"
                  label="结束时间"
                  label-width="120px"
                  :rules="[{ required: true, message: '请选择结束时间', trigger: 'blur' }]"
              >
                <el-time-select
                    placeholder="结束时间"
                    v-model="legalAidRow.service_end_date"
                    :picker-options="{
                    start: '14:30',
                    step: '00:30',
                    end: '17:30'
                  }">
                </el-time-select>
              </el-form-item>
            </template>

            <el-form-item
                prop="service_unit_time"
                label="单位服务时间"
                label-width="120px"
                :rules="[{ required: true, message: '请选择单位服务时间', trigger: 'blur' }]"
            >
              <el-select v-model="legalAidRow.service_unit_time" placeholder="请选择">
                <el-option label="15分钟" value="15"></el-option>
                <!--                <el-option label="20分钟" value="20"></el-option>-->
                <el-option label="30分钟" value="30"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button type="primary" @click="saveLegal">保存</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="form_btm">
        <el-button type="primary" @click="releaseService('save')">暂 存</el-button>
        <el-button
            v-if="!form.id"
            disabled
            type="primary"
            @click="submitForm('form','is_coupon')"
        >提交审核
        </el-button>
        <el-button
            v-else
            type="primary"
            @click="submitForm('form','is_coupon')"
        >提交审核
        </el-button>
        <!-- <el-button type="primary" @click="up" v-if="!is_editor && proid">上 架</el-button>
        <el-tooltip
          v-if="!is_editor && !proid"
          class="item"
          effect="dark"
          content="请先点击保存"
          placement="top-start"
        >
          <el-button>上 架</el-button>
        </el-tooltip>-->
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import tinymce_editor from "@/components/tinymce/tinymce_editor.vue";
import provincialSelection from "@/components/provincial_selection/provincial_selection";
import myTag from "@/components/tag/tag.vue";
import myTable from "@/components/my_table.vue";
import uploadFile from "@/components/file_upload/uploadFile.vue"; //上传组件
import uploadImg from "@/components/file_upload/uploadImg.vue"; //上传组件
import AppCropper from "@/components/crop_picture/Cropper.vue"; //裁剪图片(单图)
import CropperMulti from "@/components/crop_picture/Cropper_multi.vue"; //裁剪图片（多图）
export default {
  name: "edit",
  components: {
    myTag,
    provincialSelection,
    tinymce_editor,
    myTable,
    uploadFile,
    uploadImg,
    AppCropper,
    CropperMulti
  },
  data() {
    return {
      shop: null,
      loading: false,
      dialogAddVisible: false,
      dialogAddVisible2: false,
      curActive: "3-1", //当前选中菜单
      formLabelWidth: "112px",
      more: false, // 更多
      is_editor: false, //是否编辑
      service_type: [], // 服务类型
      main_class: [], // 专利分类
      status: [], // 法律状态
      fields: [], // 领域
      enterprisePark: [], // 服务商入驻园区
      price_discuss: false, // 是否面议
      abstractPath: "",
      dialogImageUrl: "",
      spec: {
        // 规格
        uid: "",
        id: "",
        name: "",
        money: "",
        original_money: "",
        nums: 1,
        type: "",
        unit: ""
      },
      legalAidRow: {
        name: "",
        incubator: "",
        service_time_slot: "",
        service_begin_date: "8:30",
        service_end_date: "9:30",
        service_unit_time: ""
      },
      form: {
        id: "",
        name: "", // 服务名称
        type: "", // 服务类型
        cover: "", // 封面
        coverPath: "", // 封面
        cover2: "", // 封面
        cover2Path: "", // 封面
        cover3: "", // 封面
        cover3Path: "", // 封面
        province: "", // 省份
        city: "", // 城市
        keyword: "", // 关键词
        keyword_arr: [], // 关键词arr
        synopsis: "", // 简介
        service_scale: "", // 服务规格
        class_one: "RangeServicesOther",
        class_two: "",
        file: "",
        filePath: "",
        is_coupon: false, //是否可用创新券
        fn_active: true,
        fn_status: "EntityStatusOffShelves",
        image_details: [],
        image_detailsPath: [],
        legalAid: [],
        scales: []
      },
      class_two_list: [], //服务类型子类型列表
      is_coupon_switch: true, //创新券是否可以点击
      tableObj: {
        list: [], //列表数据
        btns: [
          //按钮组
          {
            name: "编辑",
            funcName: "edit"
          },
          {
            name: "移除",
            funcName: "delete"
          }
        ],
        table_detail: [
          //table详情
          {
            prop: "name",
            label: "规格名称"
          },
          {
            prop: "money",
            label: "价格"
          },
          {
            prop: "original_money",
            label: "原价"
          },
          {
            prop: "unit",
            label: "规格单位"
          },
          {
            prop: "nums",
            label: "可售数量"
          }
        ],
        layerpageinfo: {
          //分页
          hide: true // 隐藏
        }
      },
      uploadParams: {
        //封面
        fixedNumber: [4, 3],
        shape: "rectangle",
        size: 0.5,
        ziduan: "cover",
        filePathfield: "coverPath"
      },
      uploadParams3: {
        //广告图一
        fixedNumber: [4, 3],
        shape: "rectangle",
        size: 0.5,
        ziduan: "cover2",
        filePathfield: "cover2Path"
      },
      uploadParams5: {
        //广告图二
        fixedNumber: [1, 1],
        shape: "square",
        size: 0.5,
        ziduan: "cover3",
        filePathfield: "cover3Path"
      },
      uploadParams2: {
        //详情图
        fixedNumber: [1, 1],
        limit: 5,
        shape: "square",
        size: 0.5,
        ziduan: "image_details",
        filePathfield: "image_detailsPath",
        fileList: []
      },
      uploadParams4: {
        apiParams: {
          catalog: "CatalogUserHead",
          loginKey: ""
        },
        size: 5,
        type: "ysb",
        ziduan: "file",
        filePathfield: "filePath"
      },
      apiParams: {
        params: {
          catalog: "CatalogUserHead"
        },
        size: 5, //文件大小
        type: "ysb", //类型
        imgPath: "filePath", //文件路径字段
        fileId: "file" //文件id字段
      },
      proid: "", //新增保存后商品的id
      legalAid: [
        // {
        //   name: '拓思软件园',
        //   id: '',
        //   arr: [
        //       {
        //         name: '拓思软件园',
        //         incubator: '123',
        //         service_time_slot: '每周二上午',
        //         service_begin_date: '9:00',
        //         service_end_date: '10:00',
        //         service_unit_time: '123',
        //       },
        //     {
        //       name: '拓思软件园',
        //       incubator: '123',
        //       service_time_slot: '每周二上午',
        //       service_begin_date: '9:00',
        //       service_end_date: '10:00',
        //       service_unit_time: '123',
        //     }
        //   ]
        // },
        // {
        //   name: '拓思软件园',
        //   id: '',
        //   arr: [
        //     {
        //       name: '拓思软件园',
        //       incubator: '123',
        //       service_time_slot: '每周二上午',
        //       service_begin_date: '9:00',
        //       service_end_date: '10:00',
        //       service_unit_time: '123',
        //     },
        //     {
        //       name: '拓思软件园',
        //       incubator: '123',
        //       service_time_slot: '每周二上午',
        //       service_begin_date: '9:00',
        //       service_end_date: '10:00',
        //       service_unit_time: '123',
        //     }
        //   ]
        // }
      ]
    };
  },
  computed: {
    ...mapState("service_provider", {
      authPark: state => state.authPark
    }),
    info() {
      return this.$store.state.info;
    },
    sellerInfo() {
      return this.$store.state.sellerInfo;
    },
    list() {
      return this.tableObj.list;
    }
  },
  created() {
    this.getDictionaries("ServiceShopType", "service_type");
    this.getDictionaries("RangeServicesOther", "class_two_list");
    if (this.authPark) {
      this.getData();
    } else {
      this.needAuthPark("getData");
    }

  },
  destroyed() {
    sessionStorage.removeItem("service_edit_id");
  },
  watch: {
    dialogAddVisible(newVal) {
      if (!newVal) {
        this.$refs["spec"].resetFields();
        Object.assign(this.$data.spec, this.$options.data().spec);
      }
    },
    list: {
      deep: true,
      handler() {
        this.form.service_scale = JSON.stringify(this.tableObj.list);
      }
    }
  },
  methods: {
    changeTimeSlot() {
      if (this.legalAidRow.service_time_slot.indexOf("上午") !== -1) {
        this.legalAidRow = Object.assign({}, this.legalAidRow, {
          service_begin_date: "8:30",
          service_end_date: "9:30"
        });
      } else {
        this.legalAidRow = Object.assign({}, this.legalAidRow, {
          service_begin_date: "13:30",
          service_end_date: "14:30"
        });
      }
    },
    // 单图截图后返回的路径和id
    uploadObj(params) {
      let obj = new Object();
      obj[params.ziduan] = params.fileId;
      obj[params.filePathfield] = params.filePath;
      this.form = Object.assign({}, this.form, obj);
    },
    // 多图截图后返回的路径和id
    uploadMultiObj(params) {
      this.form[params.ziduan].push(params.fileId);
      this.form[params.filePathfield].push(params.filePath);
      console.log(this.form[params.ziduan]);
    },
    //要删除的图片
    uploadRemove(params) {
      let arr = this.form[params.ziduan].filter(it => it !== params.fileId);
      this.form[params.ziduan] = arr;
    },
    /* 监测个人信息 */
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    needAuthPark(fn) {
      let watchAch = this.$watch("authPark", (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    /* 监测卖家店铺信息 */
    // needSellerInfo(fn) {
    //   let watchAch = this.$watch("sellerInfo", (val, oldVal) => {
    //     if (val) {
    //       this[fn]();
    //       watchAch(); //取消监听
    //     }
    //   });
    // },
    async getData() {
      await this.getInstitutes();
      await this.getService();
      await this.getEnterprises();
    },
    /** 查询服务商*/
    getEnterprises() {
      let params = Object.assign({}, this.layerpageinfo, this.searchObj, {
        type: "StarryExtendTypeBService",
        user_id: sessionStorage.getItem("userId"),
        status: "IdentityCertifieStatussuccess",
        pageSize: 999,
        is_default: true
      });
      this.api.getExtends(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list || [];
        this.enterprisePark = list;
      });
    },
    // 查询机构信息
    getInstitutes() {
      let params = Object.assign({}, {
        loginKey: sessionStorage.getItem("loginKey"),
        user_id: sessionStorage.getItem("userId"),
        incubator: this.authPark.incubator
      });
      return this.api.getInstitutes(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let obj = res.obj.list[0] || null;
        this.shop = obj;
      });
    },
    /**
     * 获取服务（二次编辑）
     */
    getService() {
      let id =
          this.$route.query.id || sessionStorage.getItem("service_edit_id");
      this.is_editor = id ? true : false; //编辑还是新增
      if (!this.is_editor) return;
      let obj = {
        id: id,
        institute: this.shop.id,
        user_id: sessionStorage.getItem("user_id"),
        statusCode: "EntityStatusOnShelves,EntityStatusOffShelves",
        loginKey: sessionStorage.getItem("loginKey")
      };
      let params = {...obj};

      return this.api.getServices(params).then(res => {
        if (res.error.err_code !== 0) return;
        if (res.obj.list.length > 0) this.edit(res.obj.list[0]);
      });
    },


    /**
     * 获取字典
     */
    getDictionaries(typeCode, paramName) {
      this.api.getDictionaries({
        typeCode: typeCode,
        pageNo: 0,
        pageSize: 9999
      }).then(res => {
        this[paramName] = res.obj.list;
      });
    },

    /**
     * 编辑 数据回显
     */
    async edit(obj) {
      let image_detailsPath = obj.image_detailsPath
          ? obj.image_detailsPath.split("|")
          : []; //详情图地址
      let image_details = obj.image_details ? obj.image_details.split(",") : []; //详情图id
      let fileList = [];
      for (let i = 0; i < image_detailsPath.length; i++) {
        fileList.push({
          id: image_details[i],
          url: image_detailsPath[i]
        });
      }
      this.uploadParams2.fileList = fileList; //详情图数组基本信息(回显)
      this.form.id = obj.id; //专利ID
      this.form.name = obj.name; //专利名
      this.form.type = obj.type; //专利类型
      this.form.cover = obj.cover; //封面id
      this.form.coverPath = obj.coverPath; //封面地址
      this.form.cover2 = obj.cover2; //封面id
      this.form.cover2Path = obj.cover2Path; //封面地址
      this.form.cover3 = obj.cover3; //封面id
      this.form.cover3Path = obj.cover3Path; //封面地址
      this.form.image_details = image_details; //详情图id集合
      this.form.image_detailsPath = image_detailsPath; //详情图url集合
      this.form.keyword = obj.keyword;
      if (obj.keyword) {
        this.form.keyword_arr = obj.keyword.split("|");
      }
      this.form.synopsis = obj.synopsis;
      this.form.province = obj.province;
      this.form.city = obj.city;
      this.form.is_coupon = obj.is_coupon; //是否使用创新券
      //this.is_coupon_switch = !obj.is_coupon; //创新券是否可以点击
      this.form.file = obj.fileId; //附件id
      this.form.filePath = obj.filePath; //附件id
      let class_one = obj.class_one_code;
      this.form.class_one = class_one; //服务类型
      this.form.class_two = obj.class_two_code;
      this.from = Object.assign({}, this.form);
      console.log(this.form);
      this.getServiceScales(); //获取服务规格
      this.getStarExtends();
    },

    //查询法律援助
    getStarExtends() {
      let params = {
        type: "StarExtendTypeFNService",
        entity_id: this.form.id,
        pageSize: 99999
      };
      this.api.getStarExtends(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        let legalAid = []; //法律援助列表
        list.forEach((item, index) => {
          //如果园区存在法律援助列表中
          let idx = legalAid.findIndex(it => it.incubator === item.incubator_id);
          if (idx !== -1) {
            legalAid[idx].arr.push(item);
          } else {
            legalAid.push({
              incubator: item.incubator_id,
              name: item.name,
              arr: [item]
            });
          }
        });
        console.log(legalAid);
        this.legalAid = legalAid;
        this.form.legalAid = legalAid;
      });
    },

    /**
     * 上传图片前处理
     */
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 0.5;
      if (!isLt2M) {
        this.$message.error(`详情图每张不能超过 500KB!`);
        return isLt2M;
      }
    },

    /**表单提交验证 */
    submitForm(formName, type) {
      console.log(this.form.scales);
      console.log(this.form.legalAid);
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.releaseService(type);
        } else {
          this.$message.info("请检查必填项");
          return false;
        }
      });
    },
    // 提交，保存商品
    releaseService(type) {
      if (!this.form.city) {
        this.$message.info("请选择所在地");
        return;
      }
      if (!this.form.name) {
        this.$message.info("请填写服务名称");
        return;
      }

      let operation = ""; //操作编号 保存：IdentityCertifieStatusNotSubmitted 提交：IdentityCertifieStatusSubmitted
      let id =
          this.$route.query.id || sessionStorage.getItem("service_edit_id") || "";
      let is_coupon = this.form.is_coupon;
      // 保存
      if (type === "save") {
        operation = "IdentityCertifieStatusNotSubmitted";
      }
      // 创新券提交
      else if (type === "is_coupon") {
        operation = "IdentityCertifieStatusSubmitted";
        // is_coupon = true;
      }
      //非创新券提交
      else if (type === "no_coupon") {
        operation = "IdentityCertifieStatusSubmitted";
        // is_coupon = false;
      }

      let params = Object.assign({}, this.form, {
        institute_id: this.shop.id,
        operation: operation,
        is_coupon: is_coupon,
        source_type: "SystemTypeStarry",
        id: id,
        loginKey: sessionStorage.getItem("loginKey"),
        incubator: this.authPark.incubator
      });
      // 关键词
      if (this.form.keyword_arr.length > 0) {
        params.keyword = params.keyword_arr.join("|");
      }
      //详情图
      params.image_details = this.form.image_details.length
          ? this.form.image_details.join(",")
          : ",";
      // 新增(不是二次编辑)
      if (!this.is_editor) {
        params.service_scale = JSON.stringify(this.tableObj.list);
      }
      //提交
      this.loading = true;
      this.api.releaseService(params).then(res => {
        this.loading = false;
        if (res.error.err_code !== 0) return;
        let _text = type === "save" ? "保存" : "提交";
        this.$message({
          message: _text,
          type: "success"
        });
        if (type !== "save") {
          this.$router.push({
            name: "my_service"
          });
        }
        if (res.obj.id) {
          sessionStorage.setItem("service_edit_id", res.obj.id);
          this.form.id = res.obj.id || this.form.id;
        }
        this.getServiceScales(); //获取规格
      });
    },
    /**
     * 获取服务规格
     */
    getServiceScales() {
      let id =
          this.$route.query.id || sessionStorage.getItem("service_edit_id");
      if (id) {
        let params = {
          service: id,
          loginKey: sessionStorage.getItem("loginKey")
        };

        this.api.getServiceScales(params).then(
            res => {
              this.tableObj.list = res.obj.list;
              this.form.scales = res.obj.list;
            }
        );
      }
    },

    /**
     * 保存规格
     */
    saveSpec() {
      this.$refs["spec"].validate(valid => {
        if (valid) {
          if (parseInt(this.spec.nums) <= 0) {
            this.$message({
              type: "info",
              message: "规格数量至少为1!"
            });
            return;
          }
          let id =
              this.$route.query.id || sessionStorage.getItem("service_edit_id");
          if (id) {
            // 若是编辑直接添加
            // this.form
            if (this.spec.id) {
              let params = Object.assign({}, this.spec, {
                loginKey: sessionStorage.getItem("loginKey")
              });
              this.api.updateFontServiceScale(params).then(res => {
                if (res.error["err_code"] !== 0) return;
                this.getServiceScales();
                this.dialogAddVisible = false;
              });
            } else {
              let params = Object.assign({}, this.spec, {
                service: id,
                loginKey: sessionStorage.getItem("loginKey")
              });
              this.api.createFontServiceScale(params).then(res => {
                if (res.error["err_code"] !== 0) return;
                this.getServiceScales();
                this.dialogAddVisible = false;
              });
            }
          } else {
            // 新增模拟新增查改
            let obj = JSON.parse(JSON.stringify(this.spec));
            if (obj.uid) {
              let temp = JSON.parse(JSON.stringify(this.tableObj.list));
              this.tableObj.list.forEach((val, index) => {
                if (obj.uid === val.uid) {
                  temp.splice(index, 1, obj);
                  this.tableObj.list = temp;
                  return false;
                }
              });
            } else {
              obj.uid = this.common.uuid();
              this.tableObj.list.push(obj);
            }
            this.dialogAddVisible = false;
            this.form.scales = this.tableObj.list;
          }
        } else {
          return false;
        }
      });
    },

    btnClick(obj) {
      if (obj.btnFuncName === "edit") {
        this.spec = JSON.parse(JSON.stringify(obj.row));
        this.dialogAddVisible = true;
      } else if (obj.btnFuncName === "delete") {
        this.delete(obj);
      }
    },

    /**
     * 删除规格
     * @param obj
     */
    delete(obj) {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.is_editor) {
          let params = {
            ids: obj.row.id,
            loginKey: sessionStorage.getItem("loginKey")
          };

          this.api.deleteServiceScale(params).then(
              res => {
                if (res.error.err_code !== 0) return;
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getServiceScales();
              }
          );
        } else {
          this.tableObj.list.forEach((item, index) => {
            if (obj.row.uid === item.uid) {
              this.tableObj.list.splice(index, 1);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              return false;
            }
          });
        }
      });
    },
    //保存法律援助
    saveLegal() {
      this.$refs["legal"].validate(valid => {
        if (valid) {
          let id =
              this.$route.query.id || sessionStorage.getItem("service_edit_id");
          if (id) {
            if (this.legalAidRow.id) {
              this.updateLegal(id);
            } else {
              this.createLegal(id);
            }
          }
        } else {
          false;
        }
      });
    },
    //关闭法律援助填写对话框
    closeLegalDialog() {
      this.dialogAddVisible2 = false;
      this.legalAidRow = Object.assign({}, {
        name: "",
        incubator: "",
        service_time_slot: "",
        service_begin_date: "8:30",
        service_end_date: "9:30",
        service_unit_time: ""
      });
    },
    //创建法律援助
    createLegal(id) {
      let incubator = this.enterprisePark.find(it => it.incubator === this.legalAidRow.incubator);
      let params = Object.assign({}, this.legalAidRow, {
        entity_id: id,
        type: "StarExtendTypeFNService",
        // user_id: sessionStorage.getItem('user_id'),
        loginKey: sessionStorage.getItem("loginKey"),
        name: incubator ? incubator.extend1 : "", //园区名称
        active: true
      });
      this.api.createStarExtend(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.getStarExtends();
        this.closeLegalDialog();
      });
    },
    //修改法律援助
    updateLegal(id) {
      let incubator = this.enterprisePark.find(it => it.incubator === this.legalAidRow.incubator);
      let params = Object.assign({}, this.legalAidRow, {
        entity_id: id,
        loginKey: sessionStorage.getItem("loginKey"),
        name: incubator ? incubator.extend1 : "", //园区名称
        active: true
      });
      this.api.updateStarExtend(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.getStarExtends();
        this.closeLegalDialog();
      });
    },
    //法律援助操作按钮
    tableOpt(type, row) {
      if (type === "edit") {
        this.legalAidRow = Object.assign({}, row, {
          incubator: row.incubator_id
        });
        this.dialogAddVisible2 = true;
      }
      if (type === "delete") {
        this.$confirm("确定移除该法律服务?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.deleteLegal(row);
        });
      }
    },
    //移除法律援助
    deleteLegal(row) {
      let params = {
        ids: row.id,
        loginKey: sessionStorage.getItem("loginKey"),
        active: false
      };
      this.api.deleteStarExtend(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.getStarExtends();
      });
    },

    /** 改变服务类型获取其子类*/

    // changeType(tmp, fn) {
    //   let class_one = tmp || this.form.class_one || "";
    //   if (!class_one) return;
    //   this.common.getDictionaries(class_one, res => {
    //     this.form.class_two = ""; //重新选择后清空子类
    //     this.class_two_list = res.obj.list;
    //     fn && fn();
    //   });
    // },
    /* 校验发布商品*/
    classTwoChange() {
      // this.postAxios(
      //     `/host${api.serviceClassCheck}`,
      //     { class_two: this.form.class_two },
      //     true
      // ).then(res => {
      //   if (res.error["err_code"] !== 0) return;
      //   if (res.service_class_check) {//提示创新券可用
      //     this.is_coupon_switch = false;
      //     this.form = Object.assign({}, this.form, {
      //       is_coupon: true
      //     });
      //   } else {
      //     this.is_coupon_switch = true;
      //     this.form.is_coupon = false;
      //   }
      //
      //   this.form = Object.assign({}, this.form);
      // });
    },
    /* 文件上传成功
      id 文件id
      需要赋值的字段
    **/
    uploadSuccess(params) {
      let obj = new Object();
      obj[params.ziduan] = params.fileId;
      obj[params.filePathfield] = params.filePath;
      this.form = Object.assign({}, this.form, obj);
    },
    /**
     * 上线
     */
    up() {
      this.$confirm("请确认已保存修改的信息，再上架！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.api.updateFrontService({
              status: "EntityStatusOnShelves",
              id:
                  this.$route.query.id ||
                  sessionStorage.getItem("service_edit_id"),
              loginKey: sessionStorage.getItem("loginKey")
            }).then(res => {
              if (res.error.err_code === 0) {
                this.$message({
                  type: "success",
                  message: "上架成功!"
                });
              }
            });
          })
          .catch(() => {
          });
    },
    /**过滤为整数 */

    filterNum(num) {
      this.spec.nums = parseInt(num) <= 0 ? 1 : parseInt(num);
    },
    /**过滤为2为小数点 */

    resetMoney(num) {
      this.spec.money = num.toFixed(2);
    },

    /**过滤为2为小数点 */

    resetOriMoney(num) {
      this.spec.original_money = num.toFixed(2);
    }
  }
};
</script>

<style lang="scss">
.my_service_edit {
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
  h2 {
    font-size: 20px;
    font-weight: 700;
    line-height: 40px;
    span {
      font-size: 14px;
      font-weight: 500;
      margin-left: 10px;
    }
  }
  .my_cropper .rectangle .el-upload-dragger {
    width: 80px;
    height: 80px;
  }
  .form_btm {
    z-index: 999;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 20px 0;
    background: #fff;
    box-shadow: 0 2px 10px #999;
  }
  .myupload {
    .myupload_r {
      p {
        white-space: normal;
      }
    }
  }
  .mr10 {
    margin-right: 10px;
  }
  //法律援助
  .legalAid {
    border-top: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    width: 100%;
    .legalAid_head {
      background-color: #f5f5f5;
    }
    td, th {
      padding: 15px 0;
      border-bottom: 1px solid #e5e5e5;
      border-right: 1px solid #e5e5e5;
      text-align: center;
    }
    th {
      font-weight: bold;
    }
    .opts {
      display: flex;
      justify-content: center;
      .opt_btn {
        font-size: 14px;
        color: $font-blue;
        cursor: pointer;
        margin-right: 5px;
      }
    }
  }
}
.marginTop20 {
  margin-top: 20px;
}
.width100f {
  width: 100%;
}
</style>
